import { useEffect, useState } from 'react'
import { Route, Router } from 'react-router-dom'

import history from 'app/history'
import { useAppSelector, useAppDispatch } from 'app/hooks'
import UnauthorizedRoutes from 'components/Routes/UnauthorizedRoutes'
import { LoaderOverlay } from 'components/Loader'
import { updateAuthStatusThunk } from 'features/auth/login/slice'
import SelectUserTopDomain from 'features/auth/SelectUserTopDomain'
import { selectUserIsAuthenticated } from '@racepointenergy/swc/scs/client'
import { hasUserStateLoadedSelector } from 'features/auth/login/selectors'

function App() {
  const dispatch = useAppDispatch()
  const [isReady, setIsReady] = useState(false)

  const isAuthenticated = useAppSelector(selectUserIsAuthenticated)
  const hasUserStateLoaded = useAppSelector(hasUserStateLoadedSelector)
  // When isAuthenticated we may fetch roots and render SelectUserTopDomain
  useEffect(() => {
    dispatch(updateAuthStatusThunk()).then(() => {
      setIsReady(true)
    })
  }, [dispatch])

  if ((isAuthenticated && !hasUserStateLoaded) || !isReady) {
    return <LoaderOverlay />
  }

  return (
    <Router history={history}>
      {isAuthenticated ? (
        <>
          <Route path="/:rootDomainId">
            <SelectUserTopDomain />
          </Route>
          <Route path="/" exact>
            <SelectUserTopDomain />
          </Route>
        </>
      ) : (
        <UnauthorizedRoutes />
      )}
    </Router>
  )
}

export default App
